import Tippy from "@tippyjs/react";
import React from "react";
import { BsCheckCircle, BsXCircle, BsQuestionCircle } from "react-icons/bs";
import { ReactComponent as BlueClock } from "../../../../../../assets/utils/images/svgs/BlueClock.svg";
import { HiOutlineDotsCircleHorizontal } from "react-icons/hi";

export default function ShiftStatusCell({ getValue, row, column }) {
	const status = getValue();
	let icon;
	switch (status) {
		case "Openstaand":
			icon = <HiOutlineDotsCircleHorizontal color="878EA6" />;
			break;
		case "Aangevraagd":
			icon = <BsCheckCircle color={"#3AC47D"} />;
			break;
		case "Ingepland":
			icon = <BsQuestionCircle color={"#FF8B02"} />;
			break;
		case "Uitgevoerd":
			icon = <BsQuestionCircle color={"#878EA6"} />;
			break;
		case "Geannuleerd":
			icon = <BsXCircle color={"#FB2E5F"} />;
			break;
		case "Voorlopig":
			icon = <BlueClock  />;
			break;
		default:
			icon = null;
	}

	return (
		<div className={`text-center ${!icon ? "empty" : ""}`}>
			<Tippy content={status} placement="bottom">
				<span>{icon}</span>
			</Tippy>
		</div>
	);
}
